/**
 * ReDelivery v1
 * El delivery mas coopado
 *
 * OpenAPI spec version: v1
 * Contact: redjar.redelivery@gmail.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export type EnumsOrderState = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8;

export const EnumsOrderState = {
    NUMBER_0: 0 as EnumsOrderState,
    NUMBER_1: 1 as EnumsOrderState,
    NUMBER_2: 2 as EnumsOrderState,
    NUMBER_3: 3 as EnumsOrderState,
    NUMBER_4: 4 as EnumsOrderState,
    NUMBER_5: 5 as EnumsOrderState,
    NUMBER_6: 6 as EnumsOrderState,
    NUMBER_7: 7 as EnumsOrderState,
    NUMBER_8: 8 as EnumsOrderState
};